module.exports = __webpack_public_path__ + "static/media/smiley-sad.a9023317.svg";